import store from './module/store'
import routes from './module/routes'

export default {
	name: 'checkin-super-admin',
	store: store,
	routes: routes
}